import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { I } from '../common/v5/config';

const loadSyncExchangeContacts = () => import('../redux/actions/async/admin')
	.then(mod => mod.syncExchangeContacts);

export const SyncExchangeContactsButtonBase = ({
	mailAccountId,
	onSync,
	wip,
	data
}) => {
	const handleClick = useCallback(() => {
		onSync({ mailAccountId });
	}, [mailAccountId, onSync]);

	let resultMessage = null;
	if (data) {
		if (data.reconnectRequired) {
			resultMessage = (
				<div className="text-danger">
					{data.error || I('This account needs to be reconnected to enable contact sync.')}
				</div>
			);
		} else if (typeof data.created === 'number') {
			resultMessage = (
				<div className="text-success">
					{`${data.created} ${I('created')}, ${data.updated} ${I('updated')}, ${data.skipped} ${I('skipped')}`}
				</div>
			);
		} else if (data.error) {
			resultMessage = <div className="text-danger">{data.error}</div>;
		}
	}

	return (
		<div className="form-group">
			<label className="col-lg-3 col-sm-3 col-xs-3" />
			<div className="col-lg-8 col-sm-4 col-xs-7">
				<button
					type="button"
					className="btn btn-sm btn-default"
					disabled={wip}
					onClick={handleClick}
				>
					{wip ? I('Syncing...') : I('Sync Contacts')}
				</button>
				{resultMessage}
			</div>
			<div className="col-lg-1 col-sm-1 col-xs-2" />
			<div className="clear" />
		</div>
	);
};

const mapStateToProps = state => {
	const slice = state.app.admin.admin.syncExchangeContacts || {};
	return {
		wip: !!slice.wip,
		data: slice.data
	};
};

const mapDispatchToProps = dispatch => ({
	onSync: p => loadSyncExchangeContacts().then(syncExchangeContacts => dispatch(syncExchangeContacts(p)))
});

const SyncExchangeContactsButton = connect(
	mapStateToProps,
	mapDispatchToProps
)(SyncExchangeContactsButtonBase);

export default SyncExchangeContactsButton;
